import type { ReactElement } from "react";

import Svg, { Path } from "react-native-svg";

const AppleCalendarIconSVG = ({
  height = 24,
  width = 24,
}: Partial<SizeDimensions>): ReactElement<Partial<SizeDimensions>, "svg"> => (
  <Svg fill="none" height={height} viewBox="0 0 16 18" width={width}>
    <Path
      d="M5.344.844V2.25h5.062V.844c0-.457.352-.844.844-.844.457 0 .844.387.844.844V2.25H13.5c1.23 0 2.25 1.02 2.25 2.25v11.25c0 1.266-1.02 2.25-2.25 2.25H2.25A2.221 2.221 0 0 1 0 15.75V4.5c0-1.23.984-2.25 2.25-2.25h1.406V.844C3.656.387 4.008 0 4.5 0c.457 0 .844.387.844.844ZM1.687 6.75v9c0 .316.247.563.563.563H13.5a.578.578 0 0 0 .563-.563v-9H1.687Z"
      fill="#1E2026"
    />
  </Svg>
);

export default AppleCalendarIconSVG;
